import React, { Component } from 'react';
import {
    Table, Icon, Divider, Button, Popconfirm,
} from 'antd';
import MachineLogAddContainer from '../containers/MachineLogAddContainer';
import constants from '../../constants';

class MachineLogListView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openForm: false,
            logId: null,
        };
        this.onCancel = this.onCancel.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.closeForm = this.closeForm.bind(this);
    }

    onCancel() {
        this.closeForm();
    }

    onDelete(id) {
        this.props.deleteLog(id);
    }


    confirm(e) {
        console.log(e);
        this.onDelete(e);
    }

    cancel(e) {
        console.log(e);
        // message.error('Click en ');
    }

    closeForm() {
        this.setState({
            openForm: false,
        });
    }

    render() {
        let columns = [
            {
                title: 'Fecha',
                dataIndex: 'time',
                key: 'time',
                render: text => (new Date(text).toDateString()),
            },
            {
                title: 'Tipo',
                dataIndex: 'type',
                key: 'type',
            },
            {
                title: 'Autor',
                dataIndex: 'author',
                key: 'author',
            },
        ];

        if (this.props.extraUser.type === constants.ADMIN_ROLE
            || this.props.extraUser.type === constants.SADMIN_ROLE
            || this.props.extraUser.type === constants.SUPV_ROLE) {
            columns = columns.concat({
                title: 'Opciones',
                key: 'action',
                render: (text, row) => (
                    <span>
                        <Button
                            onClick={() => {
                                this.setState({ openForm: true, logId: row.key });
                            }}
                        >
                            <Icon type="edit" />
                        </Button>
                        <Divider type="vertical" />
                        <Popconfirm title="Estas seguro que deseas eliminar esta bitacora?" onConfirm={this.confirm.bind(this, row.key)} onCancel={this.cancel} okText="Si" cancelText="No" > 
                            <Button>
                                <Icon type="delete" />
                            </Button>
                        </Popconfirm>
                    </span>
                ),
            });
        }

        const addBitacoraBtn = (
            <Button type="primary lg col-md-4 center-block" onClick={() => { this.setState({ openForm: true, logId: null }); }}>
                Agregar Nueva Bitacora
            </Button>
        );
        return (
            <div>
                <Table
                    columns={columns}
                    expandedRowRender={record => (
                        <p style={{ margin: 0 }}>
                            {record.description}
                        </p>
                    )}
                    dataSource={this.props.logs}
                />
                {this.props.extraUser.type === constants.SADMIN_ROLE && addBitacoraBtn}
                {this.props.extraUser.type === constants.ADMIN_ROLE && addBitacoraBtn}
                {this.props.extraUser.type === constants.SUPV_ROLE && addBitacoraBtn}
                {this.props.extraUser.type === constants.TEC_ROLE && addBitacoraBtn}
                <MachineLogAddContainer
                    openForm={this.state.openForm}
                    closeForm={this.closeForm}
                    onCancel={this.onCancel}
                    logId={this.state.logId}
                    user={this.props.user}
                    extraUser={this.props.extraUser}
                    machineId={this.props.machineId}
                />
            </div>
        );
    }
}

export default MachineLogListView;



// WEBPACK FOOTER //
// ./src/components/views/MachineLogListView.js